'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis.Promise;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/internals/promise-native-constructor.js
// module id = 73
// module chunks = 0